<template>
    <v-form @submit.prevent="saveClientDetails" ref="form">
        <v-card class="elevation-1 rounded-4"> 
            <v-toolbar flat height="45px">
                <span class="font-weight-bold primary--text">UPDATE CLIENT DETAILS</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
           <v-card-text>

                <!-- Client Name -->
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-item">
                        <v-text-field 
                            label="Client Name"
                            v-model="clientName"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>

                <!-- Default Currency, Contact Person -->
                <v-layout row wrap dense>

                    <!-- Default Currency  -->
                    <v-flex xs12 sm6 class="form-item">
                        <v-autocomplete
                            v-model="defaultCurrency"
                            :disabled="disabled"
                            :items="default_currencies"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Base Currency"
                            item-text="defaultCurrency"
                            item-value="defaultCurrency"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar size="24">
                                        <v-img :src="data.item.avatar" contain></v-img>
                                    </v-avatar>
                                    {{ data.item.defaultCurrency }}
                                </v-chip>
                            </template>

                            <template v-slot:item="data">
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.defaultCurrency"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.description"></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </template>

                        </v-autocomplete>
                    </v-flex>

                    <!-- Contact Person -->
                    <v-flex xs12 sm6 class="form-item">
                        <v-text-field 
                            label="Contact Person (optional)"
                            v-model="contactPerson"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>
                
                 <!-- Contact Email -->
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-item">
                        <v-text-field 
                            label="Contact Email (optional)"
                            v-model="contactEmail"
                            :rules="[rules.email]"
                            :disabled="disabled"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                </v-layout>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="mr-20">
                <v-spacer></v-spacer>
                <v-btn type="submit" class="primary" dark :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import clientApi from '@/api/client'
import { default_currencies } from '@/constants/default-currencies'

export default {
    data () {
        return {
            default_currencies,
            error: false,
            errorMessage: '',
            loading: false,
            disabled: false,

            //for refactor - put this in rules-helper.js
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                    if (!value) return true; // allow empty (optional)
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
            },
            clientId: null,
            clientCode: null,
            clientName: null,
            contactPerson: null,
            contactEmail: null,
            defaultCurrency: null
        }
    },
    methods: {
        async saveClientDetails() {
            try {
                if (this.$refs.form.validate()) { 
                    this.loading = true
                    this.disabled = true

                    const data = {
                        clientId: this.clientId,
                        clientCode: this.clientCode,
                        clientName: this.clientName,
                        contactPerson: this.contactPerson,
                        contactEmail: this.contactEmail,
                        defaultCurrency: this.defaultCurrency
                    }
                    const response = await clientApi.update(data)

                    if (response && response.status == 200) {
                        this.$emit('send', null)
                        this.loading = false
                        this.disabled = false
                        this.closeDialog()
                    }
                }
            } catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        setEdit(data) {
            if (data) {
                this.clientId = data.clientId
                this.clientCode = data.clientCode
                this.clientName = data.clientName
                this.contactPerson = data.contactPerson
                this.contactEmail = data.contactEmail
                this.defaultCurrency = data.defaultCurrency
            }else{
                this.clearForm()
            }
        },
        closeDialog() {
            this.$emit('update:dialogEditClient', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
}
</script>
<style scoped>
.form-item {
    padding: 0px 20px 0px 20px;
}
</style>